import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { Box, MenuItem } from '@mui/material';
import { useProduct } from '@revenuewell/front-end-bundle';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { FC, useCallback } from 'react';
import { PatientActionsContact } from '../types/patient-info';

export interface CallActionProps {
  onClose: () => void;
  contact?: PatientActionsContact;
}

export const CallAction: FC<CallActionProps> = (props) => {
  const { contact, onClose } = props;
  const { hasProduct } = useProduct();
  const { publish } = useEventBus();

  const arePhonesValid = useCallback(() => {
    if (!contact) return;

    return (
      (contact.cellPhone && contact.cellPhone.length > 0) ||
      (contact.workPhone && contact.workPhone.length > 0) ||
      (contact.homePhone && contact.homePhone.length > 0)
    );
  }, [contact]);

  const handleCallClick = () => {
    publish({
      messageType: 'startCall',
      data: {
        phoneNumber: contact?.cellPhone! || contact?.homePhone!
      }
    });
    onClose();
  };

  if (contact && arePhonesValid() && (hasProduct('phone') || hasProduct('phone1') || hasProduct('phone2')))
    return (
      <MenuItem onClick={handleCallClick}>
        <PhoneInTalkIcon color="primary" />
        <Box sx={{ margin: '0 20px 0 10px' }}>Call</Box>
      </MenuItem>
    );
  else return null;
};
